import { Link } from "react-router-dom";
import { useContent } from "@/context/ContentContext";
import { Spark } from "@/components/Doodles";
import { NAV_LINKS } from "@/components/Nav";

const Footer = () => {
    const { t } = useContent();
    return (
        <footer data-testid="site-footer" className="border-t-2 border-ink bg-ink px-5 pb-10 pt-14 text-cream sm:px-10">
            <div className="mx-auto max-w-7xl">
                <div className="flex flex-col gap-10 lg:flex-row lg:justify-between">
                    <div className="max-w-md">
                        <div className="flex items-center gap-3">
                            <Spark className="h-9 w-9 text-mustard" />
                            <p className="font-display text-4xl leading-none tracking-wide">PANTHER CITY CLUBHOUSE</p>
                        </div>
                        <p className="mt-3 font-hand text-2xl text-mustard -rotate-1">A gathering place for weirdos.</p>
                        <address className="mt-5 not-italic leading-relaxed text-cream/80">
                            {t("visit.address", "7264 Glenview Dr, Richland Hills, TX 76180")}
                            <br />
                            <a data-testid="footer-phone-link" href="tel:+16823342223" className="underline decoration-mustard decoration-2 underline-offset-4 hover:text-mustard">
                                {t("contact.phone", "(682) 334-2223")}
                            </a>
                            <br />
                            <a data-testid="footer-email-link" href="mailto:panthercityclubhouse@gmail.com" className="underline decoration-mustard decoration-2 underline-offset-4 hover:text-mustard">
                                {t("contact.email", "panthercityclubhouse@gmail.com")}
                            </a>
                        </address>
                    </div>
                    <nav className="grid grid-cols-2 gap-x-12 gap-y-2 self-start" aria-label="Footer">
                        <Link to="/" data-testid="footer-link-home" className="font-display text-lg tracking-wider hover:text-mustard">
                            Home
                        </Link>
                        {NAV_LINKS.map((l) => (
                            <Link key={l.to} to={l.to} data-testid={`footer-link-${l.to.slice(1)}`} className="font-display text-lg tracking-wider hover:text-mustard">
                                {l.label}
                            </Link>
                        ))}
                        <Link to="/account" data-testid="footer-link-account" className="font-display text-lg tracking-wider text-mustard hover:text-cream">
                            My Account
                        </Link>
                    </nav>
                </div>
                <div className="mt-12 flex flex-col gap-2 border-t border-cream/20 pt-6 text-xs text-cream/60 sm:flex-row sm:items-center sm:justify-between">
                    <p>© {new Date().getFullYear()} Panther City Clubhouse. All weirdos welcome.</p>
                    <p className="font-hand text-lg text-cream/70">Made with glue sticks in Fort Worth, TX.</p>
                </div>
            </div>
        </footer>
    );
};

export default Footer;
